var _path, _path2, _circle, _path3, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.699,
    height: 61.699,
    viewBox: "0 0 61.699 61.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5014",
    "data-name": "Path 5014",
    d: "M63.025,33.18A29.845,29.845,0,1,0,92.869,63.025,29.846,29.846,0,0,0,63.025,33.18Z",
    transform: "translate(-32.175 -32.175)",
    fill: "#ffde17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5015",
    "data-name": "Path 5015",
    d: "M56.529,87.378a30.85,30.85,0,1,1,21.813-9.036A30.647,30.647,0,0,1,56.529,87.378Zm0-59.689a28.84,28.84,0,1,0,28.84,28.84A28.873,28.873,0,0,0,56.529,27.689Z",
    transform: "translate(-25.68 -25.68)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 2.946,
    cy: 2.946,
    r: 2.946,
    transform: "translate(18.735 18.261)",
    fill: "#603913"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5016",
    "data-name": "Path 5016",
    d: "M162.007,162.417a3.95,3.95,0,1,1,3.95-3.95A3.954,3.954,0,0,1,162.007,162.417Zm0-5.891a1.941,1.941,0,1,0,1.941,1.941A1.943,1.943,0,0,0,162.007,156.526Z",
    transform: "translate(-140.326 -137.26)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12517",
    "data-name": "Group 12517",
    transform: "translate(36.068 17.257)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 2.945,
    cy: 2.945,
    r: 2.945,
    transform: "translate(1.005 1.005)",
    fill: "#603913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M298.912,162.417a3.95,3.95,0,1,1,3.95-3.95A3.954,3.954,0,0,1,298.912,162.417Zm0-5.891a1.941,1.941,0,1,0,1.941,1.941A1.943,1.943,0,0,0,298.912,156.526Z",
    transform: "translate(-294.962 -154.517)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12518",
    "data-name": "Group 12518",
    transform: "translate(15.871 37.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5018",
    "data-name": "Path 5018",
    d: "M159.148,317.085h0a19.939,19.939,0,0,1-14.717-6.506,1,1,0,0,1,1.486-1.352,17.889,17.889,0,0,0,26.463,0,1,1,0,1,1,1.486,1.352A19.94,19.94,0,0,1,159.148,317.085Z",
    transform: "translate(-144.169 -308.898)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.8541b45495002de2019f37f26d385602.svg";
export { ForwardRef as ReactComponent };